import hero from "../../../assets/images/hero.jpg";
import city1 from "../../../assets/images/city-1.jpg";
import city2 from "../../../assets/images/city-2.jpg";
import logo from "../../../assets/images/logo.png";

// Hero background: aerial view of an Indian residential neighbourhood.
// Photo by Zoshua Colah on Unsplash (https://unsplash.com/photos/X5KDWlLxLiM). The bundled hero.jpg is the fallback.
const HERO_BACKGROUND =
  "https://images.unsplash.com/photo-1774697443203-0f54409d1613?ixlib=rb-4.1.0&q=80&fm=jpg&crop=entropy&cs=srgb&w=1920";

export const ASSETS = { hero, heroBackground: HERO_BACKGROUND, logo };

// Site-wide configuration for the public pages (single place to change contact details and links)
export const CONTACT = {
  phone: "+91 9919190173",
  phoneHref: "tel:+919919190173",
  email: "support@allhomedesire.com",
  address: "7th Avenue, Gaur City 1, Greater Noida West, UP 201308",
};

// The mobile app is distributed through Google Play only (there is no iOS app)
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.AllHomeDesire.AllHomeDesire";

// Only Instagram and Facebook are official channels
export const SOCIALS = [
  {
    name: "Instagram",
    icon: "Instagram",
    text: "Property tours and daily interior inspiration.",
    href: "https://instagram.com/allhomedesire",
    cta: "Follow on Instagram",
    tint: "instagram",
  },
  {
    name: "Facebook",
    icon: "Facebook",
    text: "Listings, updates and buyer discussions.",
    href: "https://www.facebook.com/allhomedesire/",
    cta: "Join on Facebook",
    tint: "facebook",
  },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about-us", label: "About Us" },
  { to: "/blogs", label: "Blog" },
];

// Navbar "Services" dropdown: every service, then the partner sign-up
export const SERVICE_LINKS = [
  { to: "/property-list", label: "Property" },
  { to: "/interiordesign", label: "Interior Design" },
  { to: "/property-services", label: "Property Services" },
  { to: "/customer/bazaar", label: "Local Bazaar" },
  { to: "/customer/services", label: "Home Services" },
  { to: "/customer/healthians", label: "Healthians" },
  { to: "/partner/signup", label: "Become a Partner", divider: true },
];

export const HERO_ACTIONS = [
  { to: "/property-list", label: "View Listings", variant: "primary" },
  { to: "/partner/signup", label: "Post Your Property", variant: "outline" },
];

// Feature strip (no numeric claims; the listing total is added only when the API returns it)
export const TRUST_FEATURES = [
  { icon: "ShieldCheck", title: "Verified listings", text: "Every property is reviewed before it goes live." },
  { icon: "Tag", title: "Zero brokerage", text: "Deal directly with owners and partners." },
  { icon: "PersonCheck", title: "Expert guidance", text: "Talk to a property expert at every step." },
];

// All Services (same five services the mobile app lists). Local Bazaar, Home Services and Healthians
// live in the customer area, so visitors who are not signed in are sent to the login page first.
export const ALL_SERVICES = [
  { title: "Property", icon: "HouseDoor", text: "Buy, sell and rent verified homes, plots and commercial spaces.", to: "/property-list" },
  { title: "Interior Design", icon: "Brush", text: "Design catalogs and interior experts for every room and budget.", to: "/interiordesign" },
  { title: "Property Services", icon: "Tools", text: "Legal, loan, valuation and other services around your property.", to: "/property-services" },
  { title: "Local Bazaar", icon: "Shop", text: "Discover trusted local shops and vendors near you.", to: "/customer/bazaar" },
  { title: "Home Services", icon: "Wrench", text: "Plumbers, electricians, cleaners and more, by category.", to: "/customer/services" },
  { title: "Healthians", icon: "HeartPulse", text: "Book health and care services through our partner.", to: "/customer/healthians" },
];

export const OPTION_CARDS = [
  {
    title: "Buy A Property",
    tag: "Verified Deals",
    icon: "HouseDoor",
    text: "Browse RERA-verified apartments, villas and plots with transparent pricing and legal checks.",
    to: "/property-list?purpose=Buy",
    cta: "Browse properties",
  },
  {
    title: "Sell A Property",
    tag: "Zero Brokerage",
    icon: "Tag",
    text: "List your property in minutes and reach thousands of genuine buyers without paying commission.",
    to: "/partner/signup",
    cta: "List your property",
  },
  {
    title: "Rent A Property",
    tag: "Instant Move-in",
    icon: "Key",
    text: "Find ready-to-move rentals with verified owners, fair deposits and hassle-free paperwork.",
    to: "/property-list?purpose=Rent",
    cta: "Find a rental",
  },
];

// Decorative city photos. Counts come from the API (POST /all/property/count); a city without
// listings is not shown.
export const CITIES = [
  { name: "Bangalore", tagline: "Silicon Valley of India", image: "https://images.unsplash.com/photo-1596176530529-78163a4f7af2?q=80&w=800&auto=format&fit=crop" },
  { name: "Mumbai", tagline: "The Financial Capital", image: "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?q=80&w=800&auto=format&fit=crop" },
  { name: "Delhi NCR", tagline: "Heart of the Capital Region", image: "https://images.unsplash.com/photo-1587474260584-136574528ed5?q=80&w=800&auto=format&fit=crop" },
  { name: "Pune", tagline: "Culture meets IT", image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=800&auto=format&fit=crop" },
  { name: "Hyderabad", tagline: "Cyber City & Pearls", image: city1 },
  { name: "Noida", tagline: "Modern High-Rises", image: city2 },
];

export const STEPS = [
  { title: "Find Your Property", icon: "Search", text: "Search verified listings by city, budget and type, and shortlist the homes you love." },
  { title: "Meet Our Property Expert", icon: "PersonCheck", text: "A dedicated expert walks you through site visits, pricing and negotiation." },
  { title: "Seamless Verification", icon: "ShieldCheck", text: "We handle title, RERA and document checks so you can buy with confidence." },
  { title: "Receive The Keys", icon: "KeyFill", text: "Close the deal, complete the paperwork and move into your new home." },
];

export const APP_FEATURES = [
  "Instant alerts for new verified listings",
  "Chat directly with owners and experts",
  "Save, compare and share properties",
  "Manage your own listings on the go",
];

export const FOOTER_COLUMNS = [
  {
    title: "Quick Links",
    links: [
      { to: "/property-list?purpose=Buy", label: "Buy Properties" },
      { to: "/property-list?purpose=Rent", label: "Rent Properties" },
      { to: "/partner/signup", label: "Sell / List Property" },
      { to: "/interiordesign", label: "Interior Design" },
      { to: "/property-services", label: "Property Services" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about-us", label: "About Us" },
      { to: "/blogs", label: "Blog" },
      { to: "/contactus", label: "Contact Us" },
      { to: "/help", label: "Help & Support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy-policy", label: "Privacy Policy" },
      { to: "/terms-and-conditions", label: "Terms & Conditions" },
      { to: "/refund-policy", label: "Refund Policy" },
    ],
  },
];

export const FOOTER_BOTTOM_LINKS = [
  { to: "/privacy-policy", label: "Privacy" },
  { to: "/terms-and-conditions", label: "Terms" },
  { to: "/refund-policy", label: "Refund" },
];
